import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import UtilitiesPage from '@/components/utilities/index_page.vue'

export default class extends Controller {
  static values = {
    payload: Object
  }

  connect() {
    this.vue = createApp(UtilitiesPage, {
      payload: this.payloadValue || {}
    })

    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
